
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import TitleHeader from "@/components/base/table/header/LeftLineHeader.vue";
import { Action, Getter, State } from 'vuex-class';
import config, { FormConfig, FormValid } from '@/config';
@Component({
  name: "PersonAuthern",
  components: {
    TitleHeader,
  },
})
export default class PersonAuthern extends Vue {
  @Action('getImage') private getImage: any;
  @State("basic") private basic!: string;
  @Action("account/updateRoleBasic") private updateRoleBasic!:any;
  @Getter("id") private id!: any;
  @Getter("token") private token!: string;
  @Getter("role") private role!: string;
  @Action("upload") private upload: any;
  @Action("account/personAuthern") private personAuthern: any;
  @Action("account/getAuthernData") private getAuthern: any;
  rules_person_authern: any = {
    name: [
      {
        required: true,
        message: '请输入姓名',
        trigger: 'blur',
      },
      {validator: FormValid.name},
    ],
    socialId: [
      {
        required: true,
        message: '请输入身份证号',
        trigger: 'blur',
      },
      {validator: FormValid.idCard},
    ],
    upload: [
      {
        required: true,
        message: '请上传图片',
        trigger: 'blur',
      },
    ],
  }
  is_authern: boolean = false;
  action:any =  `${config.basicUrl}zst//page/itemDeclareForm/uploadingFile`;
  headers: any = {};
  authern_list: any = {};
  dialogImageUrl= '';
  imgData= '';
  dialogVisible= false;
  disabled= false;
  ref_authern_form: string = "ref_authern_form";
  authern_model: any = {
    upload: [],
  };
  beforeUploadImg(file: any, item: any) {
    let isEmpty = file.size > 0;
    const nameArray = file.name.split('.');
    let type = nameArray[nameArray.length - 1];
    const supportType = ['bmp', 'png', 'jpg'];
    let isVedio = supportType.includes(type);
    let isLt100M = file.size / 1024 / 1024 < 5;
    if (!isEmpty) {
      this.$message.error("不能上传空文件");
      return false;
    } else if (!isVedio) {
      this.$message.error("只能上传bmp,png,jpg类型文件");
      return false;
    } else if (!isLt100M) {
      this.$message.error("只能上传5M以内的图片");
      return false;
    }
    return isEmpty && isVedio && isLt100M;
  }
  created() {
    this.headers["accessToken"] = this.token;
    this.getData();
  }
  
  async getData() {
    const data = await this.getAuthern();
    if(data) {
      const {papersNumber: socialId, userImage, userName: name} = data;
      let upload: any = [];
      if(userImage) {
        const imgArr = userImage.indexOf(',')>=0?userImage.split(','):[userImage];
        // const baseURL = process.env.NODE_ENV === 'development'? config.basicUrl: `${location.origin}/`;
        upload = imgArr.map((item: any) => {
          let src = `${config.upImgBaseUrl}${item}`;
          return {name: src, url: src, value: item};
        })
      }
      this.authern_model = {
        socialId,
        name,
        upload,
      };
      (this.$refs[this.ref_authern_form] as any).resetFields();
      this.is_authern = true;
    }
  }
  async httpRequest({file}: any) {
    const options = new FormData();
    options.append('file', file);
    const res = await this.upload(options);
    const {code, data: url} = res;
    if(code===0) {
      const baseURL = process.env.NODE_ENV === 'development'?config.basicUrl:`${location.origin}/`;
      let fullURL = `${baseURL}zst/user/file/getPathToStream?pathUrl=${encodeURIComponent(url)}`;
      this.authern_model.upload.push({name:fullURL, url: fullURL, value: encodeURIComponent(url)})
      
      // this.authern_list.unshift({name: userImage.split('-')[userImage.split('-').length-1], url: userImage});
      // const {data: imageData} = await this.getImage({pathUrl: userImage});
      
      // this.imgData = 'data:image/png;base64,' + imageData;
    }
  }
  validFormReturn() {
    return new Promise((resolve: any, reject: any) => {
      const item: any = this.$refs[this.ref_authern_form];

      item.validate((valid: any) => {
        if (valid) {
          resolve(true)
          return true;
        }
        resolve(false)
        return false;
      });
    })
  }
  async authern() {
    const ref = this.$refs[this.ref_authern_form];
    const state = await this.validFormReturn();
    const {upload: userImage, socialId: papersNumber, name: userName} = this.authern_model;
    const options =  {
      userName,
      userId: this.id,
      userImage: userImage&&userImage.length===1?userImage[0].value:userImage[0].value+','+userImage[1].value,
      papersNumber,
      papersType: "身份证",
    }
    if(!state) {
      // return this.$message.warning("请正确填写表单内容")
      return;
    }
    this.personAuthern(options).then(({code, data, msg}: any) => {
      if(code===0&&data) {
        this.is_authern = true;
        const basic: any = this.basic;
        basic.roleSave = 1;
        this.updateRoleBasic(basic);
        return this.$message.success("实名成功!");
      }
      return this.$message.warning("认证失败!")
    })
  }
  handleRemove(file: any, fileList: any) {
    this.authern_model.upload = this.authern_model.upload.filter(({uid}: any) => uid!==file.uid)
    return fileList;
  }
  handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  handleDownload(file: any) {
  }
  beforeUpload(file: any) {
  }
  @Watch("authern_list")
  handleChange(newValue: any, oldValue: any) {
  }
}
